import React, { Component } from 'react'
import { Button, Col, Icon, Input, Row } from 'antd'
import _ from 'lodash'

import QSImageUploadWithPreview from '../QSImageUploadWithPreview/QSImageUploadWithPreview'
import './AppendixList.scss'

export default class AppendixList extends Component {
    render() {
        const {
            onAppendixItemAdd,
            onAppendixItemChange,
            onAppendixItemRemove,
            onItemChange,
            onNoticeSectionItemChange,
            type,
            status,
            sectionsList,
            noticeSection,
            appendix,
            isDocumentSent
        } = this.props
        const isLocked = isDocumentSent || type === 'working-progress' || type === 'variation-order' || status === 'inactive' || status === 'completed'
        let itemList = [],
            noticeSectionItemList = []

        if (!_.isEmpty(sectionsList))
            itemList = _.map(sectionsList, (section, sectionIdx) => {
                return _.map(section.items, (item, itemIdx) => {
                    if (item.imageUrl) {
                        const outputSectionIdx = !_.isNumber(section.original_idx) ? sectionIdx + 1 : section.original_idx + 1
                        const outputItemIdx = !_.isNumber(item.original_idx) ? itemIdx + 1 : item.original_idx + 1;
                        return (
                            <Col key={`${sectionIdx}.${itemIdx}`} className="appendix-item" span={8}>
                                <img src={item.imageUrl} alt=""/>
                                <p className="appendix-item-title">{`${outputSectionIdx}.${outputItemIdx} ${item.name}`}</p>
                                {
                                    isLocked ? <div className="appendix-item-description">{item.description}</div> :
                                    <Input 
                                        className="appendix-item-description" 
                                        placeholder="Description"
                                        value={item.description}
                                        onChange={onItemChange.bind(this, sectionIdx, itemIdx, 'description')}
                                        disabled={isLocked}
                                    />
                                }
                            </Col>
                        )
                    }
                })
            })

        if (!_.isEmpty(noticeSection))
            noticeSectionItemList = _.map(noticeSection.items, (item, itemIdx) => {
                if (item.imageUrl)
                    return (
                        <Col key={`notice.${itemIdx}`} className="appendix-item" span={8}>
                            <img src={item.imageUrl} alt=""/>
                            <p className="appendix-item-title">{`Others.${itemIdx + 1} ${item.name}`}</p>
                            {
                                isLocked ? <div className="appendix-item-description">{item.description}</div> :
                                <Input 
                                    className="appendix-item-description" 
                                    placeholder="Description"
                                    value={item.description}
                                    onChange={onNoticeSectionItemChange.bind(this, itemIdx, 'description')}
                                    disabled={isLocked}
                                />
                            }
                        </Col>
                    )
            })

        return (
            <div className="AppendixList">
                <Row gutter={16}>
                    {
                        _.map(appendix, (item, itemIdx) => (
                            <Col key={`appendix.${itemIdx}`} className="appendix-item" span={8}>
                                { !isLocked && <Icon type="close" className="appendix-item-remove-icon" onClick={onAppendixItemRemove.bind(this, itemIdx)}/> }
                                <QSImageUploadWithPreview
                                    isLocked={isLocked}
                                    itemImageUrl={item.imageUrl}
                                    itemImageChange={(url) => onAppendixItemChange(itemIdx, 'imageUrl', url)}
                                />
                                {
                                    isLocked ? <div className="appendix-item-description">{item.description}</div> :
                                    <Input 
                                        className="appendix-item-description" 
                                        placeholder="Description"
                                        value={item.description}
                                        onChange={onAppendixItemChange.bind(this, itemIdx, 'description')}
                                        disabled={isLocked}
                                    />
                                }

                            </Col>
                        ))
                    }
                    { !isLocked && <Button type="primary" onClick={onAppendixItemAdd.bind(this)}>Add Appendix Item</Button>}
                </Row>
                <Row gutter={16}>
                    { _.concat(itemList, noticeSectionItemList) }
                </Row>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Commons/AppendixList/AppendixList.js